import { Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { Shared, UserService } from "@rubii/frontend-common";
import { User } from "@rubii/frontend-common/lib/models/account/User";
import { RoleService } from "src/app/services/role.service";

@Component({
    selector: 'app-role-selector',
    templateUrl: './role-selector.component.html',
    styleUrls: ['./role-selector.component.scss']
})
export class RoleSelectorComponent {
    @Input() width: number = 285;
    @Input() selectedRoleIds: number[] = [];
    @Output() roleSelected: EventEmitter<any> = new EventEmitter();

    pannelVisible = false;


    selectedRole = {
        id: null,
        name: '',
        icon: ''
    };
    userRoles = [];

    externalRoleId = Shared.dicts.UserRoles.EXTERNAL;

    constructor(private roleService: RoleService, public userService: UserService,) {
        this.userRoles = roleService.defaultUserRoles;
    }

    ngOnInit() {
        this.checkSelectedUser();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedRoleIds) {
            this.checkSelectedUser();
        }
    }

    checkSelectedUser() {
        if (this.selectedRoleIds && this.selectedRoleIds.length) {
            let selectedId: number;
            if (this.selectedRoleIds.includes(4)) {
                selectedId = 4;
            } else if (this.selectedRoleIds.includes(1)) {
                selectedId = 1;
            } else if (this.selectedRoleIds.includes(2) || this.selectedRoleIds.includes(3)) {
                selectedId = 2;
            } 
            this.selectedRole = this.roleService.getUserRoleByRoleId(selectedId) || {
                id: null,
                name: '',
                icon: ''
            };
        }
    }

    onRoleSelected(data) {
        this.roleSelected.emit(data);
    }
}